import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const noAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const accessToken = localStorage.getItem('accessToken');

  if (!accessToken) {
    return true;
  }
  router.navigate(['/propose-transaction']);
  return false;
};
